/**
 * API client for audit log endpoints.
 * Routes: /api/mgmt/audit
 */

import { apiFetch } from './client';

export interface AuditEvent {
  eventId: string;
  actor: string;
  action: string;
  target: string;
  details: string;
  ip: string;
  timestamp: string;
}

export async function listAuditEvents(
  startDate: string,
  endDate: string,
  token: string,
  limit?: number,
): Promise<AuditEvent[]> {
  const params = new URLSearchParams({ startDate, endDate });
  if (limit) params.set('limit', String(limit));
  const data = await apiFetch<{ events: AuditEvent[] }>(
    `/api/mgmt/audit?${params.toString()}`,
    token,
  );
  return Array.isArray(data) ? data : (data.events ?? []);
}
